/**
 * The workout-count milestones (`D250`): the 10th, the 30th, the 50th and
 * every 100th workout.
 *
 * ── THE COUNT IS THE SERVER'S; WHICH COUNTS ARE ROUND IS A TABLE ────────────
 * The number itself always comes from the server — the summary's
 * `workoutNumber` (`D204`) and `GET /me/stats`' `totalSessions` (`D152`),
 * both workouts only, an abandoned session left out (`D177`). Whether that
 * number deserves a moment is a property of the number and not of the
 * history, so it needs no field on the wire, and an installed app keeps
 * drawing exactly what it drew.
 *
 * Ten, thirty and a hundred are `D152`'s `sessions_10/30/100` already. They
 * stay milestones on `/me/stats`; this is the same moment drawn as one card,
 * and {@link milestoneKeysBeside} keeps the summary from naming it twice.
 * Fifty and the hundreds after the first are new, and are never stored or
 * pushed, like every milestone here (`D152`, `D204`).
 */
const FIRST_MILESTONES = [10, 30, 50];
const EVERY = 100;
/** Whether `n` workouts is a moment worth celebrating. */
export function isWorkoutMilestone(n) {
    if (n === null || n === undefined || !Number.isInteger(n) || n <= 0) {
        return false;
    }
    return FIRST_MILESTONES.includes(n) || n % EVERY === 0;
}
const COUNT_KEY = /^milestone\.sessions_(\d+)$/;
/**
 * The summary's milestone keys less the count one the celebration card
 * already says: "10 treinos" once, as the card, never again as a line under
 * "Marcos". Every other key stays.
 */
export function milestoneKeysBeside(keys, celebrated) {
    if (celebrated === null) {
        return keys;
    }
    return keys.filter((key) => {
        const match = COUNT_KEY.exec(key);
        return match === null || Number(match[1]) !== celebrated;
    });
}
/**
 * "Falta 1 treino para fechar a semana" (`D250`): this week's count against
 * the plan's days, as `GET /me/stats` already answers it. `closed` once the
 * week is full; `remaining` with how many are left otherwise.
 */
export function weekToGo(thisWeek) {
    const left = thisWeek.scheduled - thisWeek.done;
    return left <= 0 ? { kind: "closed" } : { count: left, kind: "remaining" };
}
//# sourceMappingURL=workout-milestone.js.map